import React from 'react';
import { Layout, Seo } from 'components';
import { Row, Col } from "react-grid-system";
import "./index.scss";
import CurveLineCTA from '../../codes/components/curve-line-cta';
import CardLeftBordered from '../../codes/components/card/cardLeftBordered';
import BannerInner from '../../codes/components/banner-inner';
import videoSrc1 from "../../../static/videos/opioid-overdose-crisis-hero/hero-banner-video.mp4";
import { StaticImage } from 'gatsby-plugin-image';
import bottleIcon from '../../images/icons/bottle-icon.svg';
import requestInformationIcon from '../../images/icons/request-information-icon.svg';
import checkboxIcon from '../../images/icons/checkbox-icon.svg';
import BottomCta from '../../codes/components/bottom-cta';
import CtaImg from "../../images/opioids-and-synthetic-opiods/doctor-img.png";
import CtaSectionRightImage from '../../codes/components/cta-section-right-image';
import ContentModal from '../../codes/components/content-modal';
import useMobileSectionNavigation from '../../codes/hooks/useMobileSectionNavigation';
import potraitBgImg from '../../images/opioids-and-synthetic-opiods/portrait-bg-img.webp';
import potraitBgMobImg from '../../images/opioids-and-synthetic-opiods/portrait-bg-mob-img.webp';


const checkboxIconStyle = { width: '62px' }; // Style for the checkbox icon

const footerBottomCardData = [
	{
		id: 1,
		icon: bottleIcon,
		iconAlt: '',
		btnClass: 'btn-primary',
		btnURL: '/about-nalmefene-hcl/',
		btnText: 'Learn About Nalmefene HCl',
		mediaClass: 'bottles'
	},

	{
		id: 2,
		icon: requestInformationIcon,
		iconAlt: '',
		btnClass: 'btn-primary',
		btnURL: '/request-a-rep',
		btnText: 'Request Information',
		mediaClass: 'questions'
	},

	{
		id: 3,
		icon: checkboxIcon,
		iconAlt: '',
		btnClass: 'btn-primary no-min',
		btnURL: '/ordering-resources/',
		btnText: 'How to Order',
		mediaClass: 'checks',
		iconStyle: checkboxIconStyle,
	}
]

const Reference = (
	<>
		<p>
			<strong>References: 1. </strong>Nalmefene HCl Injection Full Prescribing Information. Purdue Pharma L.P.; 2022. <strong>2.</strong> Edinoff AN, Martinez Garza D, Vining SP, et al. New synthetic opioids: clinical considerations and dangers. <i>Pain Ther.</i> 2023;12(2):399-421. doi:10.1007/s40122-023-00481-6. <strong>3.</strong> Larnder A, Saatchi A, Borden SA, et al. Variability in the unregulated opioid market in the context of extreme rates of overdose. <i>Drug Alcohol Depend.</i> 2022;235:109427. doi:10.1016/j.drugalcdep.2022.109427. <strong>4.</strong> National Institute on Drug Abuse. Drug overdose death rates. https://nida.nih.gov/research-topics/trends-statistics/overdose-death-rates. February 9, 2023. Accessed June 26, 2023. <strong>5.</strong> National Institute on Drug Abuse. Naloxone drug facts. https://nida.nih.gov/publications/drugfacts/naloxone. June 2021. Accessed June 26, 2023. <strong>6.</strong> Barr J, Fraser GL, Puntillo K, et al. Clinical practice guidelines for the management of pain, agitation, and delirium in adult patients in the intensive care unit. <i>Crit Care Med.</i> 2013;41(1):263-306. doi:10.1097/CCM.0b013e3182783b72. <strong>7.</strong> Lautieri A. How long does heroin stay in your system? American Addiction Centers. https://americanaddictioncenters.org/heroin-treatment/how-long-in-system. Updated September 9, 2022. Accessed June 26, 2023. <strong>8.</strong> How long do opiates stay in your system? American Addiction Centers. https://americanaddictioncenters.org/prescription-drugs/how-long-in-system. Updated September 9, 2022. Accessed June 26, 2023. <strong>9.</strong> Fentanyl Citrate Injection Full Prescribing Information. Akorn, Inc.; 2012. <strong>10.</strong> Holley FO, Van Steennis C. Postoperative analgesia with fentanyl: pharmacokinetics and pharmacodynamics of constant-rate i.v. and transdermal delivery. <i>Br J Anaesth.</i> 1988;60(6):608-613. doi:10.1093/bja/60.6.608. <strong>11.</strong> Ahonen J, Olkkola KT, Hynynen M, et al. Comparison of alfentanil, fentanyl and sufentanil for total intravenous anaesthesia with propofol in patients undergoing coronary artery bypass surgery. <i>Br J Anaesth.</i> 2000;85(4):533-540. doi:10.1093/bja/85.4.533. <strong>12.</strong> Leen JLS, Juurlink DN. Carfentanil: a narrative review of its pharmacology and public health concerns. <i>Can J Anaesth</i>. 2019;66(4):414-421. doi:10.1007/s12630-019-01294-y. <strong>13.</strong> Ultram<sup>®</sup> Full Prescribing Information. Janssen Pharmaceutical Companies; 2019. <strong>14.</strong> Naloxone Hydrochloride Injection Full Prescribing Information. Hospira, Inc.; 2023. <nobr><strong>15.</strong> ZIMHI<sup>®</sup></nobr> Full Prescribing Information. Adamis Pharmaceuticals Corporation; 2021. <strong>16.</strong> OPVEE<sup>®</sup> Full Prescribing Information. Indivior Inc.; 2023. <strong>17.</strong> NARCAN<sup>®</sup> Nasal Spray Full Prescribing Information. Emergent BioSolutions Inc.; 2020. <strong>18.</strong> KLOXXADO<sup>®</sup> Nasal Spray Full Prescribing Information. Hikma Pharmaceuticals USA Inc.; 2021. <strong>19.</strong> FDA Integrated Review. Harm Reduction Therapeutics, Inc. New Drug Application for RiVive&trade;: NDA 217722. https://www.accessdata.fda.gov/drugsatfda_docs/nda/ <span style={{ whiteSpace: 'nowrap' }}>2023/217722Orig1s000IntegratedR.pdf.</span> Accessed November 29, 2023. <strong>20.</strong> Kaplan JL, Marx JA, Calabro JJ, et al. Double-blind, randomized study of nalmefene and naloxone in emergency department patients with suspected narcotic overdose. <i>Ann Emerg Med.</i> 1999;34(1):42-50. doi:10.1016/s0196-0644(99)70270-2.
		</p>
	</>
)

function OpioidOverdoseCrisis({ location }) {
	useMobileSectionNavigation({ location })
	return (
		<Layout
			pageClass="opioid-overdose-crisis-page"
			indication='hcp'
			reference={Reference}
		>
			<Seo pageTitle="Opioid Overdose Crisis" pageDescription="Learn about the increasing role synthetic opioids continue to play in the ongoing opioid overdose crisis."  pageKeywords={["Opioid overdose crisis", "opioid overdose", "synthetic opioids", "opioid antagonists", "naloxone"]} />

			<section className='block-hero' id="main-content">
				<BannerInner
					videoPath={videoSrc1}
					actorCount={2}
				>
					<Row>
						<Col lg={7.38}>
							<h1>OPIOID OVERDOSE CRISIS</h1>
							<p>Opioid overdoses are full of unknowns. The variability and potency of opioids, particularly synthetics, make reversal situations even more challenging.<sup>2,3</sup></p>
						</Col>
					</Row>
				</BannerInner>
			</section>

			<section className='block-opioids' id='p1'>
				<CurveLineCTA
					secTitle="Opioids and Synthetic Opioids"
				>
					<Row justify='between'>
						<Col lg={6}>
							<div className="left-content mb-32">
								<span className='h2 text-uppercase'>88% of OPIOID overdose deaths in 2021 involved synthetic opioids<sup>4</sup></span>
							</div>
						</Col>
						<Col lg={5}>
							<div className="right-content paragraphs">
								<p>Fentanyl and other synthetics (except methadone) <strong>increased opioid overdose deaths 7.5-fold</strong> from 2015–2021.</p>
								<p>In 2021, this number increased to <strong>70,601 overdose deaths</strong>—mostly from fentanyl.</p>
							</div>
						</Col>
					</Row>
				</CurveLineCTA>
			</section>

			<section className="block-graph bg-lightOrange">
				<div className="centered-content">
					<div className="block-graph__content">
						<span className='font-22 bold'>National Opioid-Involved Overdose Deaths, Number Among All Ages, 1999-2021<sup>4*</sup></span>

						<div className="chart-card">
							<div className="chart-card__media">
								<StaticImage
									src="../../images/charts_mobile.webp"
									alt='A graph showing the number of opioid and synthetic opioid overdose deaths  between 1999 and 2021'
									placeholder='none'
									loading='eager'
									quality={100}
									className="mobile-only"
								/>
							</div>
						</div>
						<Row gutterWidth={12} align='center' className='graph-row' wrap='nowrap'>
							<Col xs={0.6}>
								<div className="block-title desktop-only">
									<h3 className='font-22'>Number of deaths</h3>
								</div>
							</Col>
							<Col xs={11.4}>
                            <StaticImage
									src="../../images/charts_desktop.webp"
									alt='A graph showing the number of opioid and synthetic opioid overdose deaths  between 1999 and 2021'
									placeholder='none'
									loading='eager'
									quality={100}
									className="desktop-only"
								/>
                                <span className="visually-hidden">
                                        This chart displays the trends in opioid overdose deaths by type from 1999 to 2021.
                                        The green line represents synthetic opioids other than methadone, primarily fentanyl.
                                        The dashed blue line represents prescription opioids, including natural and semisynthetic opioids and methadone.
                                        The orange dotted line represents heroin.
                                        The chart shows a significant increase in synthetic opioid deaths starting from 2013.
                                    </span>
							</Col>
						</Row>

						<div className="footnote-info">
							<ContentModal
								className='modal-graph'
								buttonLabel={'Graph Description'}
							>
								<div className="block-desc">
									<p className='text-semi-bold'>National Opioid-Involved Overdose Deaths Graph Description </p>
									<p>This graph highlights the drugs that were involved in national opioid overdose deaths in all ages between the years 1999 and 2021.</p>
									<p>The chart includes specific drug-related overdose deaths broken down by 3 different drug types or classes:</p>
									<div className="list-dots">
										<ul>
											<li>Overdose deaths related to synthetic opioids other than methadone—primarily fentanyl—saw a steady surge beginning in 2015, resulting in close to 80,000 cases by 2021</li>

											<li>Overdose deaths involving use of prescription opioids, including natural and semisynthetic formulations and methadone, remained fairly consistent, with slight increases observed between 2002 through 2017, but still numbering slightly fewer than 20,000. They declined concurrently with the surge in overdose deaths from synthetic opioids, and were only slightly higher in 2021 than in 1999 (but under 5,000)</li>

											<li>Overdose deaths from heroin remained almost zero through the early 2000s, increased slightly between 2011 and 2012, reached a peak just under 10,000 deaths in 2016, and then fell to about 1,000 to 2,000 in 2021</li>
										</ul>
									</div>
									<p>Overall, the chart Includes deaths with underlying causes of unintentional drug poisoning (X40–X44), suicide drug poisoning (X60–X64), homicide drug poisoning (X85), or drug poisoning of undetermined intent (Y10–Y14), as coded in the International Classification of Diseases, 10th Revision.</p>
								</div>
							</ContentModal>
							<p className='has-asteric'><span className='asteric'>*</span>Includes deaths with underlying causes of unintentional drug poisoning (X40–X44), suicide drug poisoning (X60–X64), homicide drug poisoning (X85), or drug poisoning of undetermined intent (Y10–Y14), as coded in the International Classification of Diseases, 10th Revision.</p>
							<p>Source: Centers for Disease Control and Prevention, National Center for Health Statistics. Multiple Cause of Death 1999–2021. CDC WONDER Online Database, 01/23.</p>
						</div>
					</div>
				</div>
			</section>

			<section className="block-cta" id='p2'>
				<CtaSectionRightImage
					// videoPath={videoSrc2}
					ctaBgImg={potraitBgImg}
					ctaBgMobImg={potraitBgMobImg}
					ctaBgImgAlt=''
					ctaImg={CtaImg}
					ctaImgAlt=""
					secTitle='Opioid Reversal Agents'
				>
					<span className='h2 txt-uppercase d-block'>Opioid Reversal Agents Such as Naloxone continue to make an impact. still, more tools are needed<sup>5</sup></span>
					<p>The National Institutes of Health (NIH) supports development of stronger, longer-acting formulations of opioid antagonists to counteract high-potency synthetic opioids.<sup>5</sup></p>
				</CtaSectionRightImage>
			</section>

			<section className="block-graph block-half-lives">
				<div className="centered-content">
					<div className="block-half-lives__content">
						<div className='txt-center block-title'>
							<span className='font-22 bold text-head' role="heading" aria-level="2">HALF-LIVES CAN VARY <nobr>ACROSS OPIOIDS<sup>†</sup></nobr></span>
						</div>

						<div className="section-table-one">
							<table className='responsiveTable'>
								<thead className='table-head'>
									<tr>
										<th className='table-col'>
											<span className='font-18 bold'>Opioids</span>
										</th>
										<th className='table-col'>
											<span className='font-18 bold'>Drug</span>
										</th>
										<th className='table-col'>
											<div className="title-wrap">
												<span className='font-18 bold'>Plasma half-&#x2060;life <span className='text-regular' style={{ display: 'inline' }}>(hours)</span></span>
											</div>
										</th>
									</tr>
								</thead>

								<tbody className="table-body table-row">
									<tr>
										<td className='table-row-col bg-dark-pink'>
											<div className='inner-info'>
												<span className='font-18'>Natural</span>
											</div>
										</td>
										<td className='table-row-col bg-dark-pink'>
											<div className='inner-info'>
												<span className='sm-text'>Morphine<sup>6</sup></span>
											</div>
										</td>
										<td className='table-row-col'>
											<div className='inner-info'>
												<span className='sm-text'>3 to 4</span>
											</div>
											<div className='bar'>
												<span className='bar-width' style={{ width: 30 + '%' }}></span>
											</div>
										</td>
									</tr>

									<tr>
										<td rowSpan="3" className='table-row-col bg-dark-pink no-border-bottom'>
											<div className='inner-info'>
												<span className='font-18'>Semisynthetic</span>
											</div>
										</td>

										<td className='table-row-col bg-dark-pink'>
											<div className='inner-info'>
												<span className='sm-text'>Heroin<sup>7</sup></span>
											</div>
										</td>
										<td className='table-row-col'>
											<div className='inner-info'>
												<span className='sm-text'>0.5</span>
											</div>
											<div className='bar'>
												<span className='bar-width' style={{ width: 4 + '%' }}></span>
											</div>
										</td>
									</tr>

									<tr>
										<td className='table-row-col bg-dark-pink'>
											<div className='inner-info'>
												<span className='sm-text'>Hydromorphone<sup>6</sup></span>
											</div>
										</td>
										<td className='table-row-col'>
											<div className='inner-info'>
												<span className='sm-text'>2 to 3</span>
											</div>
											<div className='bar'>
												<span className='bar-width' style={{ width: 21 + '%' }}></span>
											</div>
										</td>
									</tr>

									<tr>
										<td className='table-row-col bg-dark-pink no-border-bottom'>
											<div className='inner-info'>
												<span className='sm-text'>Oxycodone<sup>8</sup></span>
											</div>
										</td>
										<td className='table-row-col no-border-bottom'>
											<div className='inner-info'>
												<span className='sm-text'>3 to 5</span>
											</div>
											<div className='bar'>
												<span className='bar-width' style={{ width: 38 + '%' }}></span>
											</div>
										</td>
									</tr>

									<tr className='table-border-green border-top-green border-green no-border-bottom-radius'>
										<td rowSpan="4" className='table-row-col no-border-bottom extra-border'>
											<div className='inner-info'>
												<span className='font-18'>Synthetic</span>
											</div>
										</td>

										<td className='table-row-col'>
											<div className='inner-info'>
												<span className='sm-text'>Fentanyl<sup>6, 9-11</sup></span>
											</div>
										</td>
										<td className='table-row-col'>
											<div className='inner-info bar-text'>
												<span className='sm-text semi-bold'>2 to 8</span>
											</div>
											<div className='bar'>
												<span className='bar-width' style={{ width: 53 + '%' }}></span>
											</div>
										</td>
									</tr>

									<tr className='table-border-green border-green no-border-radius'>
										<td className='table-row-col'>
											<div className='inner-info'>
												<span className='sm-text'>Carfentanil<sup>12</sup></span>
											</div>
										</td>
										<td className='table-row-col'>
											<div className='inner-info bar-text'>
												<span className='sm-text semi-bold'>5.7</span>
											</div>
											<div className='bar'>
												<span className='bar-width' style={{ width: 43 + '%' }}></span>
											</div>
										</td>
									</tr>

									<tr className='table-border-green border-green no-border-radius'>
										<td className='table-row-col'>
											<div className='inner-info'>
												<span className='sm-text'>Tramadol<sup>13</sup></span>
											</div>
										</td>
										<td className='table-row-col'>
											<div className='inner-info bar-text'>
												<span className='sm-text semi-bold'>6.3</span>
											</div>
											<div className='bar'>
												<span className='bar-width' style={{ width: 47 + '%' }}></span>
											</div>
										</td>
									</tr>

									<tr className='table-border-green border-bottom-green border-green no-border-top-radius'>
										<td className='table-row-col no-border-bottom no-border-bottom'>
											<div className='inner-info'>
												<span className='sm-text'>Methadone<sup>6</sup></span>
											</div>
										</td>
										<td className='table-row-col'>
											<div className='inner-info bar-text'>
												<span className='sm-text semi-bold'>&gt;12</span>
											</div>
											<div className='bar'>
												<span className='bar-width' style={{ width: 83 + '%' }}></span>
											</div>
										</td>
									</tr>

								</tbody>
							</table>
						</div>

						<div className="block-width-95">
							<div className="footnote-info">
								<p className='has-asteric'><span className='asteric'><sup>&dagger;</sup></span>This is not an exhaustive list of all opioids. Half-lives reported are approximations. Patient- and drug-specific variables may impact the actual half-life of a drug. Pharmacokinetic data may not necessarily correlate with clinical effects.</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="block-graph block-elimination-lives">
				<div className="centered-content">
					<div className="block-elimination-lives__content">
						<div className='txt-center block-title'>
							<span className='font-22 bold text-head' role="heading" aria-level="2">ELIMINATION HALF-LIFE OF A SAMPLING OF OPIOID ANTAGONISTS<sup>‡</sup></span>
						</div>

						<div className="section-table-two">

							<table>
								<thead>
									<tr>
										<th>
											<span className="font-18 bold">Drug</span>
										</th>
										<th>
											<span className="font-18 bold">
												Elimination{" "}
												<span className="txt-medium">
													mean plasma half-life (t<sub>1/2</sub>)
												</span>
											</span>
										</th>
										<th>
											<span className="font-18 bold desktop-only">
												Route of administration{" "}
											</span>
											<span className="font-18 bold mobile-only">
												Route of admin-istration{" "}
											</span>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<div className="inner-info">
												<span className="sm-text semi-bold">
													Nalmefene HCl<sup>1</sup>
												</span>
												<span className="sm-text">injection <nobr>2 mg/2 mL</nobr> </span>
											</div>
										</td>
										<td>
											<div className="inner-info">
												<span className="sm-text">
													10.8 hours<sup>§</sup>
												</span>
											</div>
										</td>
										<td rowSpan="2">
											<div className="inner-info">
												<span className="font-18 semi-bold">IV, IM, or SC</span>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div className="inner-info">
												<span className="sm-text semi-bold">
													Naloxone HCl (generic)<sup>14</sup>
												</span>
												<span className="sm-text">injection <nobr>0.4 mg/1 mL</nobr></span>
											</div>
										</td>
										<td>
											<div className="inner-info">
												<span className="sm-text">0.5–1.35 hours</span>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div className="inner-info">
												<span className="sm-text semi-bold">
													ZIMHI<sup>®</sup> <nobr>(naloxone HCl)</nobr><sup>15</sup>
												</span>
												<span className="sm-text">pre-filled syringe <nobr>5 mg/0.5 mL</nobr></span>
											</div>
										</td>
										<td>
											<div className="inner-info">
												<span className="sm-text">IM, 1.5 hours</span>
											</div>
										</td>
										<td>
											<div className="inner-info">
												<span className="font-18 semi-bold">IM or SC</span>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div className="inner-info">
												<span className="sm-text semi-bold">
													OPVEE<sup>®</sup> (nalmefene)<sup>16</sup>
												</span>
												<span className="sm-text">nasal spray <nobr>2.7 mg</nobr></span>
											</div>
										</td>
										<td>
											<div className="inner-info">
												<span className="sm-text">11.4 hours</span>
											</div>
										</td>
										<td rowSpan="4">
											<div className="inner-info">
												<span className="font-18 semi-bold">IN</span>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div className="inner-info">
												<span className="sm-text semi-bold">
													NARCAN<sup>®</sup> (naloxone HCl)<sup>17</sup>
												</span>
												<span className="sm-text">nasal spray <nobr>4 mg/0.1 mL</nobr></span>
											</div>
										</td>
										<td>
											<div className="inner-info">
												<span className="sm-text">Approximately 2.08 hours</span>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div className="inner-info">
												<span className="sm-text semi-bold">
													Kloxxado<sup>®</sup> (naloxone HCl)<sup>18</sup>
												</span>
												<span className="sm-text">nasal spray <nobr>8 mg/0.1 mL</nobr></span>
											</div>
										</td>
										<td>
											<div className="inner-info">
												<span className="sm-text">1.8–2.7 hours</span>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div className="inner-info">
												<span className="sm-text semi-bold">
													RiVive<sup>™</sup> <nobr>(naloxone HCl</nobr>)<sup>19</sup>
												</span>
												<span className="sm-text">nasal spray <nobr>3 mg/0.1 mL</nobr></span>
											</div>
										</td>
										<td>
											<div className="inner-info">
												<span className="sm-text">1.36 hours</span>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div className="block-width-95">
							<div className="footnote-info">
								<p>IM=intramuscular; IN=intranasal; IV=intravenous; SC=subcutaneous.</p>
								<p className='has-asteric'><span className='asteric'><sup>‡</sup></span>Not an exhaustive list of all half-lives reported across all studies conducted. Based on values reported in each respective full Prescribing Information and New Drug Application.</p>
								<p className='has-asteric'><span className='asteric'><sup>§</sup></span>Nalmefene elimination half-life is based on pharmacokinetic data. The mean terminal elimination half-life is 10.8 hours and 9.4 hours in <nobr>younger (19 to 32 years)</nobr> and elderly (62 to 80 years) healthy male subjects, respectively, following a Nalmefene HCl 1 mg IV dose.<sup>1</sup></p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className='block-hcl'>
				<div className="centered-content">
					<CardLeftBordered
						symbols={['1‖', '1¶', '1', '1', '‖', '¶', '1,20', '1']}
					>
					</CardLeftBordered>
				</div>
			</section>

			<section className='block-footer-bottom'>
				<div className="centered-content">
					<Row>
						{footerBottomCardData.map((item, index) => (
							<Col lg={4} md={6} key={item.id + index}>
								<BottomCta
									icon={item.icon}
									iconAlt={item.iconAlt}
									btnURL={item.btnURL}
									btnClass={item.btnClass}
									btnText={item.btnText}
									mediaClass={item.mediaClass}
									iconStyle={item.iconStyle}
								/>
							</Col>
						))}
					</Row>
				</div>
			</section>
		</Layout>
	);
}

export default OpioidOverdoseCrisis;
